module.exports = __webpack_public_path__ + "docs/Business-Continuity-Plan.pdf";